import React from 'react'

import { EmptyObject } from '../../../../../utils/types'

export const withUrlFragment = <TProps extends EmptyObject>(
  ComponentToWrap: React.VFC<TProps & { urlFragment: string }>,
  urlFragment: string,
): React.VFC<TProps> =>
  function WithUrlFragment(props) {
    return <ComponentToWrap urlFragment={urlFragment} {...props} />
  }
